import { render, staticRenderFns } from "./YawwButton.vue?vue&type=template&id=f192f446&scoped=true"
import script from "./YawwButton.vue?vue&type=script&lang=js"
export * from "./YawwButton.vue?vue&type=script&lang=js"
import style0 from "./YawwButton.vue?vue&type=style&index=0&id=f192f446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f192f446",
  null
  
)

export default component.exports